import { render, staticRenderFns } from "./user-manage-modal.vue?vue&type=template&id=4504350e&scoped=true&"
import script from "./user-manage-modal.vue?vue&type=script&lang=js&"
export * from "./user-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504350e",
  null
  
)

export default component.exports